package com.tovtalk.domain.usecase.auth

import com.tovtalk.domain.entity.LoginMethod
import com.tovtalk.domain.entity.DomainResult
import com.tovtalk.domain.entity.User
import com.tovtalk.domain.repository.UserRepository
import com.tovtalk.utils.config.isHadranDevice

/**
 * Login Use Case
 */
class LoginUseCase(
    private val userRepository: UserRepository,
    private val authManager: com.tovtalk.domain.repository.AuthManager
) {
    suspend operator fun invoke(
        identity: String,
        password: String?,
        loginMethod: LoginMethod,
        googleAccessToken: String? = null,
        isHadran: Boolean = isHadranDevice(),
        kosherLevelId: Int? = null
    ): DomainResult<User> {
        // Validation
        if (identity.isBlank()) {
            return DomainResult.Error("Identity cannot be empty")
        }
        
        if (loginMethod == LoginMethod.EMAIL && password.isNullOrBlank()) {
            return DomainResult.Error("Password cannot be empty")
        }
        
        // For Google login: first sign in to Firebase, then send Firebase token to backend
        val tokenToSend = if (loginMethod == LoginMethod.GOOGLE) {
            // 1. Sign in to Firebase with Google token and get Firebase ID token
            when (val firebaseResult = authManager.signInWithGoogleAndGetFirebaseToken(identity, googleAccessToken)) {
                is DomainResult.Success -> {
                    com.tovtalk.utils.logger.Logger.d("Firebase sign-in successful", "LoginUseCase")
                    firebaseResult.data
                }
                is DomainResult.Error -> {
                    com.tovtalk.utils.logger.Logger.e("Firebase sign-in failed: ${firebaseResult.message}", "LoginUseCase")
                    return DomainResult.Error("Firebase authentication failed: ${firebaseResult.message}")
                }
                is DomainResult.Loading -> {
                    return DomainResult.Error("Unexpected loading state")
                }
            }
        } else {
            identity
        }
        
        // 2. Login to Backend with Firebase token (or email for email login)
        return userRepository.login(tokenToSend, password, loginMethod, isHadran, kosherLevelId)
    }
}
